import { render } from "./AvailabilityDowntimeChart.vue?vue&type=template&id=bef033be&scoped=true"
import script from "./AvailabilityDowntimeChart.vue?vue&type=script&lang=js"
export * from "./AvailabilityDowntimeChart.vue?vue&type=script&lang=js"

import "./AvailabilityDowntimeChart.vue?vue&type=style&index=0&id=bef033be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef033be"]])

export default __exports__